// Importing necessary action type constants
import * as ACTION from '../../Redux.constants';

// Initial state for the NotebookDataReducer. By default, title and description are empty strings.
const INITIAL_STATE = {
  title: '',
  description: '',
}

/**
 * NotebookDataReducer
 * A reducer function to manage the state of notebook data such as title and description.
 * 
 * @param {Object} state - Represents the current state of the notebook data.
 * @param {Object} action - Represents the dispatched action.
 * @returns {Object} - Returns the new state of the notebook data based on the action.
 */
export function NotebookDataReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    // When the level is set, update the state with new title, description, and other generic chapters.
    case ACTION.SET_LEVEL:
      return {
        'title': action.payload.GENERAL_CONFIG.title,
        'description': action.payload.GENERAL_CONFIG.description,
        ...action.payload.GENERIC_CHAPTERS,
      };

    // For any other action, simply return the current state.
    default:
      return state;
  }
}
